import { render, staticRenderFns } from "./MainHeader.vue?vue&type=template&id=34dbb5f9&scoped=true"
import script from "./MainHeader.vue?vue&type=script&lang=js"
export * from "./MainHeader.vue?vue&type=script&lang=js"
import style0 from "./MainHeader.vue?vue&type=style&index=0&id=34dbb5f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dbb5f9",
  null
  
)

export default component.exports